/**
 * 创作者中心- 模型训练-测试模型
 * @returns
 */
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  HStack,
  Image,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Radio,
  Input,
  Select,
  RadioGroup,
  Stack,
  SliderTrack,
  SliderThumb,
  SliderFilledTrack,
  Slider,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  SimpleGrid,
  useDisclosure,
  CircularProgress,
  CircularProgressLabel,
  Icon,
  IconButton,
  Center,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
} from "@chakra-ui/react";
import {
  RiBox3Line,
  RiDeleteBin4Line,
  RiEditBoxLine,
  RiRefreshLine,
} from "@remixicon/react";
import { useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./modelSlick.css";
import { ModelTrainingParams, TrainingPicture } from "@/types/creatorcenter";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import down from "@/assets/down.svg";
import {
  selectTrainingParams,
  updateTrainingParams,
} from "@/reducer/mymodelSlice";
import TrainingPictureItem from "./trainingPictureItem";
import modelImg from "@/assets/images/creator_model_img1.png";
import IsMarkingModal from "./isMarkingModal";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Model } from "@/types/design";
import LargeModesModal from "../designComponents/largeModeModal";
import intergralIcon from "@/assets/images/icon_integral.png";
import { transform } from "typescript";
import EditModelDetailModal from "./editModelDetailModal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const TestingModal = (props: Props) => {
  const { isOpen, onClose } = props;
  const user = useSelector(selectUser);
  const MarkingControl = useDisclosure();
  const largeModeControl = useDisclosure();
  const editControl = useDisclosure();
  const dispatch = useAppDispatch();
  const trainingParams = useAppSelector(selectTrainingParams);
  const [isTesting, setIsTesting] = useState(false);

  const trainingPictures: TrainingPicture[] = [
    //   {
    //   id: "1",
    //   image: `${modelImg}`,
    //   style: "",
    //   space: "",
    //   hue: "红色",
    //   tag: ""
    // }
  ];


  const handleEditModelDetail = () => {
    editControl.onOpen();
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg="#fff" h="100vh">
        <ModalHeader>
          <Flex justifyContent={"space-between"} alignItems="center" mr="60px">
            <HStack spacing={0}>
              <Text color="#27314D" fontSize={"18px"}>
                模型训练
              </Text>
            </HStack>
            <Flex alignItems={"center"} gap="10px">
              <Button
                borderRadius={0}
                height={"40px"}
                color="#27314D"
                bg="rgba(238, 241, 247, 0.5)"
                fontWeight={"normal"}
                fontSize="14px"
                _hover={{
                  bg: "rgba(238, 241, 247, 0.5)",
                }}
                leftIcon={<RiRefreshLine size={"16px"} />}
                position={"relative"}
              >
                加强训练
              </Button>
              <Button
                borderRadius={0}
                height={"40px"}
                color="#27314D"
                bg="rgba(238, 241, 247, 0.5)"
                fontWeight={"normal"}
                fontSize="14px"
                _hover={{
                  bg: "rgba(238, 241, 247, 0.5)",
                }}
                leftIcon={<RiBox3Line size={"16px"} />}
                position={"relative"}
              >
                应用模型
              </Button>
              <Button
                borderRadius={0}
                height={"40px"}
                color="#FFFFFF"
                bgColor="#496AE1"
                fontWeight={"normal"}
                fontSize="12px"
                _hover={{
                  bgColor: "#3F5BC1",
                  color: "#E6E6E6",
                }}
                leftIcon={<RiEditBoxLine size={"16px"} />}
                position={"relative"}
                onClick={handleEditModelDetail}
              >
                编辑模型信息
              </Button>
              <IconButton
                aria-label="delete"
                borderRadius={0}
                height={"40px"}
                color="#27314D"
                bg="rgba(238, 241, 247, 0.5)"
                fontWeight={"normal"}
                fontSize="14px"
                _hover={{
                  bg: "rgba(238, 241, 247, 0.5)",
                }}
                icon={<RiDeleteBin4Line size={"16px"} />}
                position={"relative"}
              />
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody>
          <Flex h={"100%"} gap="20px">
            {/* 左侧 */}
            <Flex
              h="100%"
              flex={1}
              p="12px"
              flexDir="column"
              border="1px solid #DCE0EB"
            >
              <HStack mb="14px">
                <Box color={"#27314D"} fontWeight="bold" fontSize={"16px"}>
                  测试模型
                </Box>
                {!isTesting && (
                  <Text color={"#8E94A9"} fontSize={"12px"}>
                    以下是您训练的模型在不同场景和不同强度下的效果，在灵感创作中根据场景选择合适的强度有助于它发挥更加出色！
                  </Text>
                )}
              </HStack>

              <Box flex={1} h="0" overflowY={"auto"} position={"relative"}>
                {isTesting && (
                  <Flex
                    justifyContent={"center"}
                    alignItems="center"
                    bg="rgba(0, 0, 0, 0.9)"
                    position={"absolute"}
                    top="0px"
                    left={"0px"}
                    w="100%"
                    h="100%"
                  >
                    <Flex flexDir={"column"} alignItems="center">
                      <Box>
                        <CircularProgress
                          value={70}
                          size="80px"
                          thickness="8px"
                        >
                          <CircularProgressLabel color={"#FFFFFF"}>
                            70%
                          </CircularProgressLabel>
                        </CircularProgress>
                      </Box>
                      <Box
                        mt={"25px"}
                        color={"#FFFFFF"}
                        fontSize="18px"
                        fontWeight={350}
                      >
                        正在测试，请稍等
                      </Box>
                      <Box
                        mt={"20px"}
                        color={"#FFFFFF"}
                        fontSize="16px"
                        fontWeight={350}
                      >
                        系统将自动测试模型在不同场景、强度下的效果
                      </Box>
                      <Box
                        mt={"16px"}
                        color={"#616161"}
                        fontSize="14px"
                        fontWeight={350}
                        textAlign="center"
                      >
                        点击“应用模型”则可跳转至“AI创作”自行测试模型
                        <br />
                        可关闭此页面，测试将在后台继续运行，预计11m33s内完成训练
                      </Box>
                      <Center mt="30px">
                        <Button
                          borderRadius={0}
                          height={"40px"}
                          color="#FFFFFF"
                          bgColor="#496AE1"
                          fontWeight={"normal"}
                          fontSize="12px"
                          _hover={{
                            bgColor: "#3F5BC1",
                            color: "#E6E6E6",
                          }}
                          position={"relative"}
                        >
                          一键提速
                          <Image
                            mr="5px"
                            ml="10px"
                            boxSize={"18px"}
                            src={intergralIcon}
                          />
                          500
                        </Button>
                      </Center>
                      <Center mt="10px" color={"#616161"} fontSize="10px">
                        一键提速20%，预计5m2s内完成训练
                      </Center>
                    </Flex>
                  </Flex>
                )}

                <TableContainer>
                  <Table borderWidth="1px">
                    <Thead>
                      <Tr>
                        <Th
                          w="120px"
                          maxW={"120px"}
                          h="40px"
                          minW="120px"
                          borderWidth="1px"
                          sx={{
                            position: "relative",
                            overflow: "hidden",
                            textAlign: "center",
                            color: "#27314D",
                            fonysize: "14px",
                          }}
                          _before={{
                            content: '""',
                            position: "absolute",
                            top: "0%",
                            width:
                              "1px" /* Large number to ensure it covers the entire width */,
                            height: "125px",
                            background: "gray.200",
                            left: 0,
                            transform: "rotate(288deg)",
                            transformOrigin: "top",
                          }}
                        >
                          <Box position="absolute" top={"2px"} right="5px">
                            LoRA强度
                          </Box>
                          <Box position="absolute" bottom={"2px"} left="5px">
                            描述词
                          </Box>
                        </Th>
                        <Th p="0" textAlign="center" borderWidth="1px" color="#27314D" fontSize={"14px"}>
                          强度:0%
                        </Th>
                        <Th p="0" textAlign="center" borderWidth="1px" color="#27314D" fontSize={"14px"}>
                          强度:20%
                        </Th>
                        <Th p="0" textAlign="center" borderWidth="1px" color="#27314D" fontSize={"14px"}>
                          强度:35%
                        </Th>
                        <Th p="0" textAlign="center" borderWidth="1px" color="#27314D" fontSize={"14px"}>
                          强度:50%
                        </Th>
                        <Th p="0" textAlign="center" borderWidth="1px" color="#27314D" fontSize={"14px"}>
                          强度:65%
                        </Th>
                        <Th p="0" textAlign="center" borderWidth="1px" color="#27314D" fontSize={"14px"}>
                          强度:80%
                        </Th>
                        <Th p="0" textAlign="center" borderWidth="1px" color="#27314D" fontSize={"14px"}>
                          强度:100%
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      <Tr fontSize="14px">
                        <Td
                          bg="rgba(238, 241, 247, 0.5)"
                          borderWidth="1px"
                          color={"#3D3D3D"}
                          whiteSpace="normal"
                        >
                          建筑, 临街商业, 现代风格, 体块穿插, 米白色石材
                        </Td>
                        <Td
                          bg="rgba(238, 241, 247, 0.5)"
                          borderWidth="1px"
                          color={"#3D3D3D"}
                          whiteSpace="normal"
                        ></Td>
                        <Td
                          bg="rgba(238, 241, 247, 0.5)"
                          borderWidth="1px"
                          color={"#3D3D3D"}
                          whiteSpace="normal"
                        ></Td>
                        <Td
                          bg="rgba(238, 241, 247, 0.5)"
                          borderWidth="1px"
                          color={"#3D3D3D"}
                          whiteSpace="normal"
                        ></Td>
                        <Td
                          bg="rgba(238, 241, 247, 0.5)"
                          borderWidth="1px"
                          color={"#3D3D3D"}
                          whiteSpace="normal"
                        ></Td>
                        <Td
                          bg="rgba(238, 241, 247, 0.5)"
                          borderWidth="1px"
                          color={"#3D3D3D"}
                          whiteSpace="normal"
                        ></Td>
                        <Td
                          bg="rgba(238, 241, 247, 0.5)"
                          borderWidth="1px"
                          color={"#3D3D3D"}
                          whiteSpace="normal"
                        ></Td>
                        <Td
                          bg="rgba(238, 241, 247, 0.5)"
                          borderWidth="1px"
                          color={"#3D3D3D"}
                          whiteSpace="normal"
                        ></Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
            </Flex>
            {/* 右侧 */}
            <Box
              w="352px"
              h="100%"
              border="1px solid #DCE0EB"
              p="12px"
              boxSizing="border-box"
              overflow={"auto"}
            >
              <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
                mb="20px"
                background="rgba(238, 241, 247, 0.5)"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        模型信息
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel borderTop="1px solid #DCE0EB">
                    <TableContainer>
                      <Table borderWidth="1px">
                        <Tbody>
                          <Tr fontSize="14px">
                            <Td
                              // borderColor="gray.200"
                              // borderWidth="0 1px 1px 0"
                              borderWidth="1px"
                              color={"#8E94A9"}
                              p="10px"
                            >
                              模型名称
                            </Td>
                            <Td
                              p="10px"
                              borderWidth="1px"
                              whiteSpace="normal"
                              color={"#27314D"}
                            >
                              光怪陆离的建筑
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              类型
                            </Td>
                            <Td
                              borderWidth="1px"
                              p="10px"
                              whiteSpace="normal"
                              color={"#27314D"}
                            >
                              室内设计
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              基础模型
                            </Td>
                            <Td
                              color={"#27314D"}
                              borderWidth="1px"
                              p="10px"
                              whiteSpace="normal"
                            >
                              官方建筑模型-基础算法_v1.5
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              训练方向
                            </Td>
                            <Td
                              color={"#27314D"}
                              borderWidth="1px"
                              p="10px"
                              whiteSpace="normal"
                            >
                              风格
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              图片类型
                            </Td>
                            <Td
                              color={"#27314D"}
                              p="10px"
                              borderWidth="1px"
                              whiteSpace="normal"
                            >
                              渲染图
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              触发标签
                            </Td>
                            <Td
                              color={"#27314D"}
                              borderWidth="1px"
                              p="10px"
                              whiteSpace="normal"
                            >
                              ALD001
                            </Td>
                          </Tr>
                          <Tr fontSize="14px">
                            <Td borderWidth="1px" color={"#8E94A9"} p="10px">
                              模型类型
                            </Td>
                            <Td
                              color={"#27314D"}
                              borderWidth="1px"
                              p="10px"
                              whiteSpace="normal"
                            >
                              LoRA
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              <Accordion
                allowToggle
                defaultIndex={[0]}
                borderColor={"#E2E8F0"}
                borderWidth="0 1px 0 1px"
                background="rgba(238, 241, 247, 0.5)"
                mb="20px"
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex="1"
                        textAlign="left"
                        color={"#27314D"}
                      >
                        训练素材
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel borderTop="1px solid #DCE0EB">
                    <SimpleGrid columns={2} spacing={"14px"}>
                      <Box
                        bg="rgba(238, 241, 247, 0.5)"
                        border={"1px solid #CBD1DF"}
                      >
                        <Image boxSize={"137px"} objectFit="contain" src="" />
                      </Box>
                      <Box
                        bg="rgba(238, 241, 247, 0.5)"
                        border={"1px solid #CBD1DF"}
                      >
                        <Image boxSize={"137px"} objectFit="contain" src="" />
                      </Box>
                    </SimpleGrid>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </Box>
          </Flex>
          <EditModelDetailModal isOpen={editControl.isOpen}
            onClose={editControl.onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TestingModal;
